module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"waste":"Atık","energy":"Enerji","water":"Su","other":"Diğer","consumption":"Enerji","supplychain":"Diğer"},"en":{"waste":"Waste","energy":"Energy","water":"Water","other":"Other","consumption":"Energy","supplychain":"Other"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Data/Main.vue
// module id = UdiJ
// module chunks = 1